import React from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import useEnvironment from "./useEnvironment"

function OptionalMeta(props) {
  const { property, content } = props
  if (!content) {
    return null
  }

  return <meta property={property} content={content} />
}

OptionalMeta.propTypes = {
  property: PropTypes.string.isRequired,
  content: PropTypes.string
}

OptionalMeta.defaultProps = {
  content: undefined
}

export default function WebSiteMetaProvider({ children }) {
  const env = useEnvironment()
  return (
    <>
      <Helmet>
        {env?.meta?.title && <title>{env?.meta?.title}</title>}
        <OptionalMeta property="og:title" content={env?.meta?.og?.title} />
        <OptionalMeta
          property="og:description"
          content={env?.meta?.og?.description}
        />
      </Helmet>
      {children}
    </>
  )
}

WebSiteMetaProvider.propTypes = {
  children: PropTypes.any.isRequired
}
